var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.985107,
    y: 0.900024,
    width: 48.8,
    height: 47.2,
    rx: 23.6,
    fill: "#45C655"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.293 16.9H15.8772C14.8322 16.9 13.9851 17.7471 13.9851 18.7921V30.2079C13.9851 31.2529 14.8322 32.1 15.8772 32.1H27.293C28.338 32.1 29.1851 31.2529 29.1851 30.2079V18.7921C29.1851 17.7471 28.338 16.9 27.293 16.9ZM34.7901 18.3923L30.4518 21.3848V27.6152L34.7901 30.6038C35.6293 31.1817 36.7851 30.5919 36.7851 29.5825V19.4136C36.7851 18.4081 35.6332 17.8144 34.7901 18.3923Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.33563e740955a252cc663d4861255d52.svg";
export { ForwardRef as ReactComponent };